(() => {
  if (window.nskmWhatsAppCheckoutConsent) return;
  window.nskmWhatsAppCheckoutConsent = true;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  function enhance() {
    // Whatmore's direct cart permalink skips cart attributes. Use its own
    // variant-aware product link so the noticed storefront checkout is used.
    document.querySelectorAll('.wht-neo-sn-buynow').forEach(button => {
      if (button.dataset.waVideoRoute) return;
      const panel = button.closest('.wht-neo-sn-panel');
      if (!panel?.querySelector('.wht-neo-sn-viewmore')) return;
      button.dataset.waVideoRoute = 'yes';
      button.textContent = 'Continue to product';
    });
    document.querySelectorAll('.shopify-payment-button').forEach(payment => {
      const form = payment.closest('form');
      if (!form || form.dataset.waBuyNow) return;
      form.dataset.waBuyNow = 'yes';
      const panel = document.createElement('div');
      panel.dataset.waProductNotice = 'yes';
      panel.style.cssText = 'margin:12px 0;font-size:14px;line-height:1.5';
      panel.textContent = 'By clicking Buy it now, you agree to receive your order confirmation and delivery updates from Tiny Shiny Gifts on WhatsApp at the mobile number entered at checkout. Reply STOP to opt out.';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--full-width button--primary';
      button.dataset.waConsent = 'yes';
      button.dataset.waBuyNow = 'yes';
      button.textContent = 'Buy it now';
      payment.replaceWith(panel, button);
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(buttons => {
      if (document.querySelector('[name="checkout"][data-wa-consent="yes"]')) buttons.hidden = true;
    });
  }
  function showError(form, message) {
    let error = form.querySelector('[data-wa-checkout-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.waCheckoutError = 'yes';
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.textContent = message;
  }
  async function checkout(button, form) {
    if (busy || button.disabled) return;
    busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const attributes = {
      whatsapp_opt_in: 'yes',
      whatsapp_opt_in_source: button.dataset.waBuyNow ? 'storefront_buy_now_button' : 'storefront_checkout_button',
      whatsapp_opt_in_version: 'tiny-shiny-checkout-notice-v3',
      whatsapp_opt_in_at: new Date().toISOString()
    };
    try {
      const saved = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({attributes})
      });
      if (!saved.ok) throw Error('Could not prepare checkout. Please try again.');
      const cart = await saved.json();
      if (Object.entries(attributes).some(([key, value]) => cart.attributes?.[key] !== value)) {
        throw Error('Could not prepare checkout. Please try again.');
      }
      if (button.dataset.waBuyNow) {
        const variant = form.querySelector('[name="id"]');
        if (!variant || variant.disabled || !variant.value) throw Error('Please select an available product option.');
        const added = await fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: {Accept: 'application/json'}, body: new FormData(form)
        });
        if (!added.ok) {
          const result = await added.json().catch(() => ({}));
          throw Error(result.description || 'Could not add this product. Please try again.');
        }
      }
      window.location.assign(root + 'checkout');
    } catch (error) {
      showError(form, error.message || 'Checkout could not open. Please try again.');
      button.disabled = false;
      button.removeAttribute('aria-busy');
      busy = false;
    }
  }
  document.addEventListener('click', event => {
    const videoButton = event.target.closest?.('.wht-neo-sn-buynow');
    if (videoButton) {
      const productButton = videoButton.closest('.wht-neo-sn-panel')?.querySelector('.wht-neo-sn-viewmore');
      if (!productButton || videoButton.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      productButton.click();
      return;
    }
    const button = event.target.closest?.('[data-wa-consent="yes"]');
    if (!button?.form || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void checkout(button, button.form);
  }, true);
  document.addEventListener('submit', event => {
    const button = event.submitter;
    if (button?.dataset.waConsent !== 'yes') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void checkout(button, event.target);
  }, true);
  window.addEventListener('pageshow', () => {
    busy = false;
    document.querySelectorAll('[data-wa-consent][aria-busy="true"]').forEach(button => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  });
  enhance();
  new MutationObserver(enhance).observe(document.documentElement, {childList: true, subtree: true});
})();
